import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { CsPage, NavController } from 'providers/nav-controller';
import { DatabaseWrapper, DocWatcher } from 'services/database-wrapper';
import { UserDb } from 'services/user-db.service';
import { LoggingService } from 'services/logging.service';
import { DeclaredState } from '@cf-shared/data-model/user-state';

import { LL } from 'i18n/i18n.service';
@Component({
  selector: 'page-advanced-training-methods',
  templateUrl: 'advanced-training-methods-page.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvancedTrainingMethodsPage extends CsPage<{}> {
  protected LL = LL;
  protected loading = false;
  declaredState: DeclaredState;
  private docWatcher: DocWatcher;

  constructor(
    public navCtrl: NavController,
    private userDb: UserDb,
    private cd: ChangeDetectorRef,
    private logging: LoggingService,
  ) {
    super();
  }

  async ionViewCanEnter() {
  }

  async ngOnInit() {
    if (!this.docWatcher) {
      this.docWatcher = this.userDb.database.createDocWatcher((_changes) => {
        if (this.viewDestroyed) return;
        this.cd.markForCheck();
      });
    }

    try {
      this.loading = true;
      this.cd.markForCheck();

      this.declaredState = await this.userDb.loadDeclaredStateAsync(this.docWatcher);

    } finally {
      this.loading = false;
      this.cd.markForCheck();
    }
  }

  async ionViewWillEnter() {
    this.loading = true;
    this.cd.markForCheck();

    this.declaredState = await this.userDb.loadDeclaredStateAsync(this.docWatcher);

    this.loading = false;
    this.cd.markForCheck();
  }

  async handleChange() {
    await this.saveChanges();
  }

  ngOnDestroy() {
    this.docWatcher?.destroy();
  }

  private async saveChanges() {
    try {
      await this.userDb.saveDeclaredStateAsync(DatabaseWrapper.getTransactionId());
      this.cd.markForCheck();
    } catch (error) {
      // the toggle on screen says the setting changed, but it was not saved: tell the person
      this.logging.trackAbnormalException(error);
    }
  }

}
